<script setup>
import api from "../api/api";
import ButtonSubmit from "./ButtonSubmit.vue";
import HomeViewSampleReport from "./HomeViewSampleReport.vue";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
</script>

<template>
  <div class="main-div">
    <div class="card-header">
      <div class="card-header-title">
        {{ label }}
        <span v-if="filterBreadcrumb" class="card-header-breadcrumb">{{ filterBreadcrumb }}</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px;">
        <button class="pill-btn" @click.prevent="toggle = !toggle" v-show="!toggle">Show</button>
        <button class="pill-btn" @click.prevent="toggle = !toggle" v-show="toggle">Hide</button>
      </div>
    </div>

    <div
      class="parent"
      v-show="toggle"
      v-if="
        surveyReportByProgramAndIteration.length == 0 &&
        tippingPointReport.length == 0 &&
        pressurePointReport.length == 0 &&
        boardReport.length == 0
      "
    >
      <h2>No coaching report(s) available.</h2>
    </div>

    <!--survey report-->
    <div
      class="parent"
      v-show="toggle"
      v-for="reports in paginatedSurveyReports"
      :key="reports"
    >
      <div class="card-header" style="width: 100%;">
        <div class="card-header-title" style="text-transform: none; letter-spacing: normal; font-size: var(--body-md-size, 14px);">
          Program: {{ reports.program_name }} Iteration: {{ reports.iteration_name }}
        </div>
        <div style="display: flex; align-items: center; gap: 8px;">
          <button class="pill-btn" @click.prevent="reports.reportToggle = !reports.reportToggle" v-show="!reports.reportToggle">Show</button>
          <button class="pill-btn" @click.prevent="reports.reportToggle = !reports.reportToggle" v-show="reports.reportToggle">Hide</button>
        </div>
      </div>
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in reports.report_details"
        :key="report"
        v-show="reports.reportToggle"
      >
        <div>
          <h4>Coachee Individual Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h3>For: {{ report.full_name }}</h3>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
        </div>
        <div>
          <div v-if="report.survey_type == 1">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/big5_survey_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 6">
            <img
              class="surveyLogo baseline"
              src="../../public/survey_logo/baseline_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 2">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/360_survey_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 3">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/research_survey_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 5">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/VFP_logo.png"
            />
          </div>
        <div
          v-if="
            report.survey_type == 4 &&
            report.report_file == 'QSort-BEP-Report.html'
          "
        >
          <img
            class="surveyLogo"
            src="../../public/survey_logo/qSort_BEP.png"
          />
        </div>
        <div
          v-if="
            report.survey_type == 4 &&
            report.report_file == 'QSort-GDP-Report.html'
          "
        >
          <img
            class="surveyLogo"
            src="../../public/survey_logo/qSort_GDP.png"
          />
        </div>
        <div
          v-if="
            report.survey_type == 4 &&
            report.report_file == 'QSort-OCM-Report.html'
          "
        >
        </div>
        </div>
        <!-- <a href="#">View Sample Individual Report</a> -->

        <!-- release report right away -->
        <div v-if="!isLoadingAllowCoachesToReleaseReports">
          <div v-if="report.allow_coaches_to_release_reports == 1 && report.coach_access_granted == 1">
            <p>Report status: {{ report.release_status }}</p>
            <label class="switch">
              <input
                type="checkbox"
                v-model="report.release_status"
                true-value="released"
                false-value="not released"
                @change="
                  coachReleaseParticipantReport(
                    report.survey_assignment_id,
                    'yes',
                    report
                  )
                "
              />
              <span class="slider round"></span>
            </label>
          </div>
          <div v-else>
            <!-- You can add a message here if allow_coaches_to_release_reports is 0 -->
          </div>
        </div>
        <div v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div><span>Loading release report feature..</span></div>
        </div>

          <!--360-->
        <div
          class="tooltip"
          v-if="
            report.coach_access_granted == 1 &&
            report.not_eligible == 1 &&
            report.dropped_status == 0 &&
            report.report_file.includes('360')
          "
        >
          Is your coachee eligible?
          <span class="tooltiptext"
            >- Your coachee must have 2 respondents <br /><br />
            - You coachee must have a self assessment</span
          >
        </div>

        <ButtonSubmit
          v-if="
            !Number(report.coach_access_granted) &&
            report.dropped_status == 0 &&
            report.survey_type == 2
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />
        <ButtonSubmit
          v-if="
            report.coach_access_granted == 1 &&
            report.not_eligible == 1 &&
            report.dropped_status == 0 &&
            report.report_file.includes('360')
          "
          disabled
          label="Not eligible for a report"
          style="margin-top: 10px"
        />

        <!-- <a
        v-if="
            report.coach_access_granted == 1 &&
            report.not_eligible == 0 &&
            report.dropped_status == 0 &&
            report.report_file.includes('360')
          "
          class="pdf-url"
          @click="showReportPdf(report.full_name, 
          report.report_template_name, 
          report.survey_assignment_id)"
          >Show {{ report.report_template_name }} pdf</a
        > -->
        <!-- 360 button -->
        <button
          v-if="
            report.coach_access_granted == 1 &&
            report.not_eligible == 0 &&
            report.dropped_status == 0 &&
            report.report_file.includes('360')
          "
          @click="openInNewTab360Report(`${brandData.website_url + report.report_file}?sex=${
            report.gender
          }&country=${report.country}&viewer_fullname=${
            userData.first_name + ' ' + userData.last_name
          }&report_for_fullname=${report.full_name}&survey_assignment_id=${
            report.survey_assignment_id
          }&org_id=${report.org_id}&subOrg_id=${report.suborg_id}&program_id=${
            report.program_id
          }&iteration_id=${report.iteration_id}&coach_id=${
            report.coach_id
          }&survey_template_id=${report.survey_template_id}&rand=${rand}`, report.final_deadline_date)"
          >
          <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Individual Report
            </router-link>
          </button>

        <!--Big five or Big 5 view report button-->
        <!-- <a
        v-if="
            report.dropped_status == 0 &&
            report.coach_access_granted == 1 &&
            report.report_file.includes('5Step')
          "
          class="pdf-url"
          @click="showReportPdf(report.full_name, 
          report.report_template_name, 
          report.survey_assignment_id)"
          >Show {{ report.report_template_name }} pdf</a
        > -->
        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            !Number(report.coach_access_granted) &&
            report.report_file.includes('5Step')
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />
        <a
          v-if="
            report.dropped_status == 0 &&
            report.coach_access_granted == 1 &&
            report.report_file.includes('5Step')
          "
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Individual Report
            </router-link>
        </a>

        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            !Number(report.coach_access_granted) &&
            report.report_file.includes('Baseline')
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />

        <a
          v-if="
            report.dropped_status == 0 &&
            report.coach_access_granted == 1 &&
            report.report_file.includes('Baseline')
          "
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Individual Report
            </router-link>
        </a>

        <!-- VFP button -->

        <!-- <a
        v-if="
            report.dropped_status == 0 &&
            report.coach_access_granted == 1 &&
            report.report_file.includes('VFP')
          "
          class="pdf-url"
          @click="showReportPdf(report.full_name, 
          report.report_template_name, 
          report.survey_assignment_id)"
          >Show {{ report.report_template_name }} pdf</a
        > -->

        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            !Number(report.coach_access_granted) &&
            report.report_file.includes('VFP')
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />

        <a
          v-if="
            report.dropped_status == 0 &&
            report.coach_access_granted == 1 &&
            report.report_file.includes('VFP')
          "
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Individual Report
            </router-link>
        </a>
<!--BEP-->
        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            !Number(report.coach_access_granted) &&
            report.report_file.includes('QSort-BEP')
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />
        <a
          v-if="
            report.dropped_status == 0 &&
            report.coach_access_granted == 1 &&
            report.report_file.includes('QSort-BEP')
          "
> 
          <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData),
                          QsortBEP: qsortBEP
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Interactive Report
            </router-link>
            </a>

        <!--OCM-->

        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            !Number(report.coach_access_granted) &&
            report.report_file.includes('QSort-OCM')
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />

        <a
          v-if="
            report.dropped_status == 0 &&
            report.coach_access_granted == 1 &&
            report.report_file.includes('QSort-OCM')
          "
          > 
          <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData),
                          QsortOCM: qsortBEP
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Interactive Report
            </router-link>
            </a>

        <!--GDP-->
        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            !Number(report.coach_access_granted) &&
            report.report_file.includes('QSort-GDP')
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />
        <a
          v-if="
            report.dropped_status == 0 &&
            report.coach_access_granted == 1 &&
            report.report_file.includes('QSort-GDP')
          "
          > 
          <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData),
                          QsortGDP: qsortBEP
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Interactive Report
            </router-link>
            </a>
        <!-- Global button -->

        <!-- <a
        v-if="
            report.dropped_status == 0 &&
            report.coach_access_granted == 1 &&
            !report.report_file.includes('5Step') &&
            !report.report_file.includes('VFP') &&
            !report.report_file.includes('360')
          "
          class="pdf-url"
          @click="showReportPdf(report.full_name, 
          report.report_template_name, 
          report.survey_assignment_id)"
          >Show {{ report.report_template_name }} pdf</a
        > -->

        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            !Number(report.coach_access_granted) &&
            !report.report_file.includes('5Step') &&
            !report.report_file.includes('VFP') &&
            !report.report_file.includes('360') &&
            !report.report_file.includes('Baseline') &&
            !report.report_file.includes('GDP') &&
            !report.report_file.includes('OCM') &&
            !report.report_file.includes('BEP')
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />
        
        <a
          v-if="
            report.dropped_status == 0 &&
            report.coach_access_granted == 1 &&
            !report.report_file.includes('5Step') &&
            !report.report_file.includes('VFP') &&
            !report.report_file.includes('360') &&
            !report.report_file.includes('Baseline') &&
            !report.report_file.includes('GDP') &&
            !report.report_file.includes('OCM') &&
            !report.report_file.includes('BEP')
          "
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Individual Report
            </router-link>
        </a>

        <ButtonSubmit
          v-if="
            report.dropped_status == 1
          "
          disabled
          label="Dropped"
          style="margin-top: 10px"
        />

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--Tipping point report-->
    <div
      class="parent"
      v-show="toggle"
      v-for="reports in filteredTippingPointReport"
      :key="reports"
    >
      <div class="card-header" style="width: 100%;">
        <div class="card-header-title" style="text-transform: none; letter-spacing: normal; font-size: var(--body-md-size, 14px);">
          Program: {{ reports.program_name }} Iteration: {{ reports.iteration_name }} Reports: {{ reports.report_template_name }}
        </div>
        <div style="display: flex; align-items: center; gap: 8px;">
          <button class="pill-btn" @click.prevent="reports.reportToggle = !reports.reportToggle" v-show="!reports.reportToggle">Show</button>
          <button class="pill-btn" @click.prevent="reports.reportToggle = !reports.reportToggle" v-show="reports.reportToggle">Hide</button>
        </div>
      </div>
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in reports.report_details"
        :key="report"
        v-show="reports.reportToggle"
      >
        <div>
          <h4>Coachee Individual Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h3>For: {{ report.full_name }}</h3>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/tipping_point_logo.png"
          />
        </div>

        <!--Tipping point view report button-->

        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            !Number(report.coach_access_granted) &&
            report.report_file == 'TIPpingPointReport.html'
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />


        <!-- <a
        v-if="
            report.report_file.includes('TIPping') &&
            report.dropped_status == 0 &&
            report.coach_access_granted == 1
          "
          class="pdf-url"
          @click="showReportPdf(report.full_name, 
          report.report_template_name, 
          report.survey_assignment_id)"
          >Show {{ report.report_template_name }} pdf</a
        > -->

        <a
          v-if="
            report.report_file.includes('TIPping') &&
            report.dropped_status == 0 &&
            report.coach_access_granted == 1
          "
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Individual Report
            </router-link>
        </a>

        <ButtonSubmit
          v-if="
            report.dropped_status == 1 &&
            report.report_file.includes('TIPping')
          "
          disabled
          label="Dropped"
          style="margin-top: 10px"
        />

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--pressure point report-->
    <div
      class="parent"
      v-show="toggle"
      v-for="reports in filteredPressurePointReport"
      :key="reports"
    >
      <div class="card-header" style="width: 100%;">
        <div class="card-header-title" style="text-transform: none; letter-spacing: normal; font-size: var(--body-md-size, 14px);">
          Program: {{ reports.program_name }} Iteration: {{ reports.iteration_name }} Reports: {{ reports.report_template_name }}
        </div>
        <div style="display: flex; align-items: center; gap: 8px;">
          <button class="pill-btn" @click.prevent="reports.reportToggle = !reports.reportToggle" v-show="!reports.reportToggle">Show</button>
          <button class="pill-btn" @click.prevent="reports.reportToggle = !reports.reportToggle" v-show="reports.reportToggle">Hide</button>
        </div>
      </div>
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in reports.report_details"
        :key="report"
        v-show="reports.reportToggle"
      >
        <div>
          <h4>Coachee Individual Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h3>For: {{ report.full_name }}</h3>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/pressure_point_logo.png"
          />
        </div>

        <!--Pressure point view report button-->

        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            !Number(report.coach_access_granted) &&
            report.report_file.includes('Pressure')
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />

        <!-- <a
        v-if="
            report.report_file.includes('Pressure') &&
            report.dropped_status == 0 &&
            report.coach_access_granted == 1
          "
          class="pdf-url"
          @click="showReportPdf(report.full_name, 
          report.report_template_name, 
          report.survey_assignment_id)"
          >Show {{ report.report_template_name }} pdf</a
        > -->


        <a
          v-if="
            report.report_file.includes('Pressure') &&
            report.dropped_status == 0 &&
            report.coach_access_granted == 1
          "
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Individual Report
            </router-link>
        </a>

        <ButtonSubmit
          v-if="
            report.dropped_status == 1 &&
            report.report_file.includes('Pressure')
          "
          disabled
          label="Dropped"
          style="margin-top: 10px"
        />

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--board report-->
    <div
      class="parent"
      v-show="toggle"
      v-for="reports in filteredBoardReport"
      :key="reports"
    >
      <div class="card-header" style="width: 100%;">
        <div class="card-header-title" style="text-transform: none; letter-spacing: normal; font-size: var(--body-md-size, 14px);">
          Program: {{ reports.program_name }} Iteration: {{ reports.iteration_name }} Reports: {{ reports.report_template_name }}
        </div>
        <div style="display: flex; align-items: center; gap: 8px;">
          <button class="pill-btn" @click.prevent="reports.reportToggle = !reports.reportToggle" v-show="!reports.reportToggle">Show</button>
          <button class="pill-btn" @click.prevent="reports.reportToggle = !reports.reportToggle" v-show="reports.reportToggle">Hide</button>
        </div>
      </div>
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in reports.report_details"
        :key="report"
        v-show="reports.reportToggle"
      >
        <div>
          <h4>Coachee Individual Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h3>For: {{ report.full_name }}</h3>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/big5_survey_logo.png"
          />
        </div>

        <!--Board report view report button-->

        <ButtonSubmit
          v-if="
            report.dropped_status == 0 &&
            !Number(report.coach_access_granted) &&
            report.report_file.includes('NED Report')
          "
          disabled
          label="No permission to view"
          style="margin-top: 10px"
        />

        <router-link 
          v-if="
            report.report_file.includes('NED Report') &&
            report.dropped_status == 0 &&
            report.coach_access_granted == 1
          "
          class="btn-submit" 
          :to="{
            name: 'MyReport',
            query: { 
              reportData: encrypt(JSON.stringify(report)),
              userData: JSON.stringify(userData),
              brandData: JSON.stringify(brandData)
            }
          }" 
          target="_blank">  
          View Individual Report
        </router-link>

        <ButtonSubmit
          v-if="
            report.dropped_status == 1 &&
            report.report_file.includes('NED Report')
          "
          disabled
          label="Dropped"
          style="margin-top: 10px"
        />

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <router-link 
          v-if="coachId"
          class="btn-submit" 
          :to="{
            name: 'MyReport',
            query: { 
              reportData: encrypt(JSON.stringify(report)),
              userData: JSON.stringify(userData),
              brandData: JSON.stringify(brandData)
            }
          }" 
          target="_blank">  
          Admin access to report
        </router-link>
      </div>
    </div>

    <!--Coach Group report-->
    <div class="parent" v-show="toggle" v-if="coachGroup5StepReport.length > 0">
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachGroup5StepReport"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/big5_survey_logo.png"
          />
        </div>

        <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              '5Step.html',
              14845,
              'Sample User',
              38,
              64,
              1,
              17,
              23
            )
          "
          >View Sample Report</a
        >

        <!--Coach group view report button-->

        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!-- Baseline -->
    <div
      class="parent"
      v-show="toggle"
      v-if="coachProgramBaselineReport.length > 0"
    >
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachProgramBaselineReport"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/big5_survey_logo.png"
          />
        </div>

        <!-- <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              '5Step.html',
              14845,
              'Sample User',
              38,
              64,
              1,
              17,
              23
            )
          "
          >View Sample Report</a
        > -->
        <!--Coach group view report button-->

        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--5Step-->
    <div
      class="parent"
      v-show="toggle"
      v-if="coachProgram5StepReport.length > 0"
    >
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachProgram5StepReport"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/big5_survey_logo.png"
          />
        </div>

        <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              '5Step.html',
              14845,
              'Sample User',
              38,
              64,
              1,
              17,
              23
            )
          "
          >View Sample Report</a
        >
        <!--Coach group view report button-->

        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--Tipping point-->
    <div
      class="parent"
      v-show="toggle"
      v-if="coachTippingReportSorted.length > 0"
    >
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachTippingReportSorted"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/tipping_point_logo.png"
          />
        </div>

        <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              'TIPpingPointReport.html',
              14845,
              'Sample User',
              38,
              64,
              1,
              17,
              23
            )
          "
          >View Sample Report</a
        >
        <!--Coach group view report button-->

        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--Pressure point-->
    <div
      class="parent"
      v-show="toggle"
      v-if="coachPressureReportSorted.length > 0"
    >
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachPressureReportSorted"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/pressure_point_logo.png"
          />
        </div>

        <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              'PressurePointReport.html',
              14845,
              'Sample User',
              38,
              64,
              1,
              17,
              23
            )
          "
          >View Sample Report</a
        >
        <!--Coach group view report button-->

        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--TS 360-->
    <div
      class="parent"
      v-show="toggle"
      v-if="coachProgramTalentSage360Report.length > 0"
    >
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachProgramTalentSage360Report"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/360_survey_logo.png"
          />
        </div>

        <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              'TalentSage360Report.html',
              14849,
              'Sample User',
              38,
              59,
              1,
              17,
              29
            )
          "
          >View Sample Report</a
        >
        <!--Coach group view report button-->

        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--Gen Man 360-->
    <div
      class="parent"
      v-show="toggle"
      v-if="coachProgramGeneralManager360Report.length > 0"
    >
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachProgramGeneralManager360Report"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/360_survey_logo.png"
          />
        </div>

        <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              'GeneralManager360Report.html',
              14846,
              'Sample User',
              38,
              60,
              1,
              17,
              25
            )
          "
          >View Sample Report</a
        >

        <!--Coach group view report button-->

        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--Sep 360-->
    <div
      class="parent"
      v-show="toggle"
      v-if="coachProgramSeniorExecProgram360Report.length > 0"
    >
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachProgramSeniorExecProgram360Report"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/360_survey_logo.png"
          />
        </div>

        <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              'SeniorExecProgram360Report.html',
              14848,
              'Sample User',
              38,
              63,
              1,
              17,
              27
            )
          "
          >View Sample Report</a
        >

        <!--Coach group view report button-->

        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>
        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--Team Leader 360-->
    <div
      class="parent"
      v-show="toggle"
      v-if="coachProgramTeamLeader360Report.length > 0"
    >
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachProgramTeamLeader360Report"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/360_survey_logo.png"
          />
        </div>

        <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              'TeamLeader360Report.html',
              14850,
              'Sample User',
              38,
              61,
              1,
              17,
              31
            )
          "
          >View Sample Report</a
        >

        <!--Coach group view report button-->
        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--Help 360-->
    <div class="parent" v-show="toggle" v-if="coachHelp360Report.length > 0">
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachHelp360Report"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/360_survey_logo.png"
          />
        </div>

        <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              'HELP360Report.html',
              14847,
              'Sample User',
              38,
              62,
              1,
              17,
              33
            )
          "
          >View Sample Report</a
        >

        <!--Coach group view report button-->
        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>
    </div>

    <!--EuroNav 360-->
    <div class="parent" v-show="toggle" v-if="coachEuroNav360Report.length > 0">
      <div
        class="child"
        style="background-color: #cdcdcd"
        v-for="report in filteredCoachEuroNav360Report"
        :key="report"
      >
        <div>
          <h4>Coaching Group Report</h4>
          <hr />
          <p>{{ report.program_name }}</p>
          <div v-if="report.stream_name != null && report.group_name == null">
            <p>{{ report.stream_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name != null"
          >
            <p>{{ report.group_name }}</p>
          </div>
          <div
            v-else-if="report.stream_name == null && report.group_name == null"
          >
            <p></p>
          </div>
          <div
            v-else-if="report.stream_name != null && report.group_name != null"
          >
            <p>{{ report.stream_name }}/{{ report.group_name }}</p>
          </div>
          <h2>{{ report.iteration_name }}</h2>
          <h2>{{ report.report_template_name }}</h2>
          <h3 v-if="report.group_name != null">
            For group: {{ report.group_name }}
          </h3>
          <h3 v-else-if="report.group_name == null">For group: (No group)</h3>
        </div>
        <div>
          <img
            class="surveyLogo"
            src="../../public/survey_logo/360_survey_logo.png"
          />
        </div>

        <a
          class="sample-report-href"
          @click="
            showCoachGroupSampleReport(
              'EURONAV360Report.html',
              survey_assignment_id,
              'Sample User',
              38,
              61,
              1,
              17,
              23
            )
          "
          >View Sample Report</a
        >

        <!--Coach group view report button-->
        <a
          v-if="
            report.report_file.includes('Coach') ||
            report.report_file.includes('coach')"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              View Group Report
            </router-link>
        </a>

        <div class="tooltip" v-if="coachId" style="margin-top: 10px">
          Information
          <span class="tooltiptext"
            >- Above this tooltip shows exactly what the coach see in their
            report tile screen.
            <br />
            <br />- This tooltip and the button under this only shows for Admin
            to view the report.</span
          >
        </div>
        <a
          v-if="coachId"
          >
            <router-link class="btn-submit" :to="{
              name: 'MyReport',
              query: { 
                          reportData: encrypt(JSON.stringify(report)),
                          userData: JSON.stringify(userData),
                          brandData: JSON.stringify(brandData)
                      } // <-- changed 'props' to 'params'
              }" target="_blank">  
              Admin access to report
            </router-link>
        </a>
      </div>

      <!-- Pagination for Survey Reports -->
      <div v-if="filteredSurveyReportByProgramAndIteration.length > 0 && totalPagesSurveyReports > 1" class="pagination-container">
        <button 
          class="pagination-btn" 
          :disabled="currentPageSurveyReports === 1"
          @click="goToPageSurveyReports(currentPageSurveyReports - 1)">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        
        <button 
          v-for="page in displayedPagesSurveyReports" 
          :key="page"
          class="pagination-btn"
          :class="{ 'active': page === currentPageSurveyReports }"
          @click="goToPageSurveyReports(page)">
          {{ page }}
        </button>
        
        <button 
          class="pagination-btn" 
          :disabled="currentPageSurveyReports === totalPagesSurveyReports"
          @click="goToPageSurveyReports(currentPageSurveyReports + 1)">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
        
        <div class="pagination-info">
          Page {{ currentPageSurveyReports }} of {{ totalPagesSurveyReports }}
          <span v-if="activeFilters">({{ filteredSurveyReportByProgramAndIteration.length }} filtered / {{ surveyReportByProgramAndIteration.length }} total)</span>
          <span v-else>({{ surveyReportByProgramAndIteration.length }} total reports)</span>
        </div>
      </div>
    </div>

    <HomeViewSampleReport
      v-if="showCoachGroupSampleModal == true"
      @close-modal="showCoachGroupSampleModal = false"
      :surveyAssignmentId="survey_assignment_id"
      :suborg="suborg_id"
      :surveyTemplateId="survey_template_id"
      :programId="program_id"
      :iterationId="iteration_id"
      :coachId="coach_id"
      :orgId="org_id"
      :reportForFullName="report_for_fullname"
      :viewerFullName="viewer_fullname"
      :reportLink="report_link"
      :brandData="brandData"
      :userData="userData"
    />

    <HomeViewSampleReport
      v-if="showCoachSampleModal == true"
      @close-modal="showCoachSampleModal = false"
      :surveyAssignmentId="survey_assignment_id"
      :suborg="suborg_id"
      :surveyTemplateId="survey_template_id"
      :programId="program_id"
      :iterationId="iteration_id"
      :coachId="coach_id"
      :orgId="org_id"
      :reportForFullName="report_for_fullname"
      :viewerFullName="viewer_fullname"
      :reportLink="report_link"
      :brandData="brandData"
      :userData="userData"
    />
  </div>
</template>

<script>
export default {
  components: [ButtonSubmit, HomeViewSampleReport],
  name: "HomeCohortReports",
  data: () => ({
    showCoachGroupSampleModal: false,
    showCoachSampleModal: false,
    toggle: true,
    reportData: [],
    currentPageSurveyReports: 1,
    itemsPerPage: 9999,
    org_id: "",
    survey_assignment_id: 0,
    suborg_id: "",
    survey_template_id: "",
    program_id: "",
    iteration_id: "",
    coach_id: 0,
    report_for_fullname: "",
    viewer_fullname: "",
    report_link: "",
    reportGroupData: [],
    rand: "",
    pdfReportTemplateId: "",
    qsortBEP: "BEP",
    qsortGDP: "GDP",
    qsortOCM: "OCM",
    abortController: new AbortController(), 
    isLoadingAllowCoachesToReleaseReports: true,
  }),
  props: {
    userData: Object,
    brandData: Object,
    reportName: String,
    surveyName: String,
    dateTime: String,
    buttonLabel: String,
    label: String,
    buttonColor: String,
    coachId: Number,
    activeFilters: Object,
  },
  watch: {
    activeFilters: {
      handler() {
        this.currentPageSurveyReports = 1;
      },
      deep: true
    }
  },
  async mounted() {
      this.rand = Math.random();
      this.isLoadingAllowCoachesToReleaseReports = true;

      try {
          let apiUrl = this.coachId
              ? `get-coach-reports-by-admin/${this.coachId}`
              : `get-coach-reports/${this.userData.ind_id}`;

          // Fetch report data and wait for completion
          const response = await api.get(apiUrl, { signal: this.abortController.signal });
          this.reportData = response.data.map(report => ({
              ...report,
              allow_coaches_to_release_reports: report.allow_coaches_to_release_reports ?? 0 // Default to 0 if missing
          }));

          // Additional processing
          this.processReportData();
          await this.fetchAdditionalData();
          await this.fetchIterationsData();

      } catch (error) {
          if (error.name !== 'AbortError') {
              // Handle error
          }
      } finally {
          if (this.reportData.length > 0) {
            for (const report of this.reportData) {

                if (report.allow_coaches_to_release_reports == 1) {
                    try {
                        const res = await api.post(`/coach-release-report-by-survey_assignment_id`, {
                            surveyAssignmentId: report.survey_assignment_id,
                            modifyReport: "no"
                        });
                        report.release_status = res.data.message === "released" ? "released" : "not released";
                    } catch (error) {
                        console.error('Error releasing report:', error);
                    }
                }
            }
          }
          this.isLoadingAllowCoachesToReleaseReports = false;
      }
  },


  methods: {

      goToPageSurveyReports(page) {
        if (page >= 1 && page <= this.totalPagesSurveyReports) {
          this.currentPageSurveyReports = page;
          const parentDiv = this.$el.querySelector('.parent');
          if (parentDiv) {
            parentDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      },

      async coachReleaseParticipantReport(surveyAssignmentId, releaseStatus, report) {
        try {
          const response = await api.post(`/coach-release-report-by-survey_assignment_id`, {
            surveyAssignmentId: surveyAssignmentId,
            modifyReport: releaseStatus
          });

          const { message } = response.data;

          const foundReport = this.reportData.find(r => r.survey_assignment_id === surveyAssignmentId);
          if (foundReport) {
            Object.assign(foundReport, { release_status: message === "released" ? "released" : "not released" });
          }

          // Only send email when toggling TO released
          if (message === "released" && report) {
            await this.sendParticipantReportEmailNow(report);
          }

          // Add history log
          try {
            const historyResponse = await api.post(`/create-user-history-log`, {
              ind_id: this.userData.ind_id,
              email: this.userData.email,
              screen: 'Coach Home Screen',
              action: `Coach release participant report`,
              action_description: `Report release status changed to ${message} for survey_assignment_id ${surveyAssignmentId}`,
            });
            
            if (historyResponse.status === 200) {
              console.log('User history log recorded:', historyResponse);
            }
          } catch (historyError) {
            console.error('Error logging user history:', historyError);
          }
        } catch (error) {
          console.error("Error releasing report:", error);
        }
      },


      async sendParticipantReportEmailNow(report) {
        Swal.fire({
          title: 'Sending Report Email...',
          text: 'Please wait and do not close this window.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          const response = await api.post('/send-participant-report-email-now', {
            survey_assignment_id: report.survey_assignment_id,
            ind_id: report.ind_id,
            org_id: report.org_id,
            suborg_id: report.suborg_id,
            program_id: report.program_id,
            survey_type: report.survey_type
          });

          Swal.fire({
            title: 'Email Sent!',
            text: `Report email successfully sent to ${response.data.send_to}.`,
            icon: 'success',
            confirmButtonColor: this.brandData.accent_color1,
            confirmButtonText: 'OK'
          });

        } catch (error) {
          console.error('Error sending report email:', error);
          Swal.fire({
            title: 'Failed to Send',
            text: 'Something went wrong while sending the email. Please try again.',
            icon: 'error',
            confirmButtonColor: this.brandData.accent_color1,
            confirmButtonText: 'OK'
          });
        }
      },

      async fetchIterationsData() {
        try {
            const requests = this.reportData.map(async (report) => {
                try {
                    const response = await api.get(`iterations/${report.iteration_id}`, {
                        signal: this.abortController.signal
                    });

                    // Assign the fetched value to the report
                    report.allow_coaches_to_release_reports = response.data.allow_coaches_to_release_reports;
                } catch (error) {
                    if (error.name !== 'AbortError') {
                        console.error(`Error fetching iteration data for report ${report.iteration_id}:`, error);
                    }
                }
            });

            await Promise.all(requests);
        } catch (error) {
            console.error("Error fetching iterations data:", error);
        }
    },
    processReportData() {
        this.reportData.forEach((dataEle) => {
            let existingRgd = this.reportGroupData.find(
                (rgd) =>
                    rgd?.program_name === dataEle.program_name &&
                    rgd?.iteration_name === dataEle.iteration_name
            );

            if (existingRgd) {
                existingRgd.report_details.push(dataEle);
            } else {
                this.reportGroupData.push({
                    ...dataEle,
                    is_group_report: 0,
                    reportToggle: true,
                    report_details: [dataEle],
                });
            }
        });

        this.reportGroupData.forEach((data) => {
            data.report_details.sort((a, b) =>
                a.full_name.localeCompare(b.full_name)
            );
        });
    },

    async fetchAdditionalData() {
        const promises = this.reportData
            .filter(report => report.survey_assignment_id !== 0)
            .map(async (report) => {
                try {
                    const [eligibilityRes, surveyRes] = await Promise.all([
                        api.get(`get-not-eligible360/${report.survey_assignment_id}`, {
                            signal: this.abortController.signal
                        }),
                        api.get(`survey-results-sex-country/${report.survey_assignment_id}`, {
                            signal: this.abortController.signal
                        })
                    ]);

                    // Update all reports with the same survey_assignment_id
                    if (eligibilityRes.data) {
                        const matchingReports = this.reportData.filter(
                            item => item.survey_assignment_id === report.survey_assignment_id
                        );
                        matchingReports.forEach(reportItem => {
                            reportItem.not_eligible = eligibilityRes.data.not_eligible;
                        });
                    }

                    if (surveyRes.data) {
                        const matchingReports = this.reportData.filter(
                            item => item.survey_assignment_id === report.survey_assignment_id
                        );
                        matchingReports.forEach(reportItem => {
                            const surveyData = surveyRes.data.find(
                                resItem => resItem.survey_assignment_id === report.survey_assignment_id
                            );
                            if (surveyData) {
                                reportItem.gender = surveyData.gender;
                                reportItem.country = surveyData.country;
                            }
                        });
                    }
                } catch (error) {
                    if (error.name !== 'AbortError') {
                        console.error('Error fetching additional data:', error);
                    }
                }
            });

        await Promise.all(promises);
    },
    encrypt(src) {
      let passphrase = "rptData"
      return CryptoJS.AES.encrypt(src, passphrase).toString();
    },
    // async showReportPdf(reportFullName, reportTemplateName, surveyAssignmentId){
    //   this.setLoading = true
    //   let url = null
    //   const pdfName = this.removeSpaces(reportFullName+reportTemplateName)
    //   const requestBodyForCoach = {
    //         report_template_id: pdfName,
    //         survey_assignment_id: surveyAssignmentId,
    //       };

    //   await api.post("/get-pdf-generated-for-coach", requestBodyForCoach)
    //   .then(async (res)=>{
    //     this.pdfReportTemplateId = res.data

    //     if(this.setLoading === true){
    //     this.showPdfAlert()
    //   }
    //     try {
    //       const requestBody = {
    //         report_template_id: this.pdfReportTemplateId,
    //         survey_assignment_id: surveyAssignmentId,
    //       };

    //       const response = await api.post('/get-pdf-content', requestBody, {
    //         responseType: 'blob', // Specify the response type as blob
    //       });
  
    //       // Create a blob URL from the response data
    //       const blob = new Blob([response.data], { type: 'application/pdf' });
    //       url = window.URL.createObjectURL(blob);

    //       if(url !== null){
    //         window.open(url, '_blank');
    //         this.setLoading = false
    //         if(this.setLoading === false){
    //           this.hidePdfAlert()
    //           console.log("URL ", url)
    //         }
    //       }
    //       // Open the PDF in a new tab
          
    //     } catch (error) {
    //       console.error('Error downloading PDF:', error);
    //       // Handle errors here
    //     }
    //   })
    // },

    // async showPdfAlert(){
    //   Swal.fire({
    //     title: "Preparing your pdf, please wait...",
    //     allowOutsideClick: false,
    //     didOpen: () => {
    //       Swal.showLoading();
    //     },
    //   });
    // },

    // async hidePdfAlert(){
    //   Swal.close()
    // },

    // async removeSpaces(inputString) {
    //   return inputString.replace(/\s/g, '');
    // },
    
    myReport(
      report_file,
      survey_assignment_id,
      report_full_name,
      report_program_id,
      report_iteration_id,
      report_org_id,
      report_suborg_id,
      report_survey_template_id,
      report_coach_id
    ) {
      // get sex and country first
      api
        .get(`survey-results-sex-country/${survey_assignment_id}`), {signal: this.abortController.signal}
        .then((res) => {
          let data;
          if (res.data.length > 0) {
            data = {
              survey_assignment_id: survey_assignment_id,
              report_link: this.brandData.website_url + report_file,
              viewer_fullname:
                this.userData.first_name + " " + this.userData.last_name, //login user
              country: res.data[0].answer,
              sex: res.data[1].answer,
              report_for_fullname: report_full_name,
              org_id: report_org_id,
              suborg_id: report_suborg_id,
              program_id: report_program_id,
              iteration_id: report_iteration_id,
              survey_template_id: report_survey_template_id,
              coach_id: report_coach_id,
            };
          } else {
            data = {
              survey_assignment_id: survey_assignment_id,
              report_link: this.brandData.website_url + report_file,
              viewer_fullname:
                this.userData.first_name + " " + this.userData.last_name, //login user
              report_for_fullname: report_full_name,
              org_id: report_org_id,
              suborg_id: report_suborg_id,
              program_id: report_program_id,
              iteration_id: report_iteration_id,
              survey_template_id: report_survey_template_id,
              coach_id: report_coach_id,
            };
          }
          this.$router.push({
            name: "MyReport",
            params: { data: JSON.stringify(data) },
          });
        });
    },

    myCoachGroupReport(
      report_file,
      survey_assignment_id,
      report_program_id,
      report_iteration_id,
      report_org_id,
      report_suborg_id,
      report_survey_template_id,
      report_coach_id
    ) {
      // get sex and country first
      let data;
      data = {
        survey_assignment_id: survey_assignment_id,
        report_link: this.brandData.website_url + report_file,
        report_for_fullname:
          this.userData.first_name + " " + this.userData.last_name,
        org_id: report_org_id,
        suborg_id: report_suborg_id,
        program_id: report_program_id,
        iteration_id: report_iteration_id,
        survey_template_id: report_survey_template_id,
        coach_id: report_coach_id,
      };
      this.$router.push({
        name: "MyReport",
        params: { data: JSON.stringify(data) },
      });
    },

    showCoachGroupSampleReport(
      report_file,
      survey_assignment_id,
      full_name,
      program_id,
      iteration_id,
      org_id,
      suborg_id,
      survey_template_id
    ) {
      this.showCoachSampleModal = true;
      this.viewer_fullname =
        this.userData.first_name + " " + this.userData.last_name;
      this.report_for_fullname = full_name;
      this.report_link = this.brandData.website_url + report_file;
      this.suborg_id = suborg_id;
      this.survey_template_id = survey_template_id;
      this.program_id = program_id;
      this.iteration_id = iteration_id;
      this.org_id = org_id;
      this.survey_assignment_id = survey_assignment_id;
    },

    showCoachSampleReport(
      report_file,
      survey_template_id,
      survey_assignment_id,
      program_id,
      iteration_id,
      org_id,
      suborg_id,
      coach_id,
      full_name
    ) {
      this.showCoachSampleModal = true;
      this.viewer_fullname =
        this.userData.first_name + " " + this.userData.last_name;
      this.report_for_fullname = full_name;
      this.report_link = this.brandData.website_url + report_file;
      this.suborg_id = suborg_id;
      this.survey_template_id = survey_template_id;
      this.program_id = program_id;
      this.iteration_id = iteration_id;
      this.org_id = org_id;
      this.coach_id = coach_id;
      this.survey_assignment_id = survey_assignment_id;
    },
    openInNewTab360Report(url, finalDeadlineDate) {
      const today = new Date()
      // Convert the string to a Date object for proper comparison
      const deadlineDate = new Date(finalDeadlineDate)
      
      if(deadlineDate > today){
        Swal.fire({
          text: "The Program is still open. Participant and Cohort Scores are subject to change.",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: this.brandData.accent_color1,
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            console.log("Cannot be viewed")
          }
        })
      } else {
        console.log("Ready to view")
        // Open the report in new tab
        window.open(url, '_blank')
      }
    },

  },

  computed: {
    filterBreadcrumb() {
      if (!this.activeFilters) {
        return '';
      }

      const parts = [];
      
      // Organization
      if (this.activeFilters.organization) {
        parts.push(this.activeFilters.organization.name);
        
        // Sub-Organization
        if (this.activeFilters.subOrganization) {
          parts.push(this.activeFilters.subOrganization.name);
          
          // Program
          if (this.activeFilters.program) {
            parts.push(this.activeFilters.program.name);
            
            // Iteration
            if (this.activeFilters.iteration) {
              parts.push(this.activeFilters.iteration.name);
              
              // Stream
              if (this.activeFilters.stream) {
                parts.push(this.activeFilters.stream.name);
                
                // Group
                if (this.activeFilters.group) {
                  parts.push(this.activeFilters.group.name);
                } else {
                  const groupCount = this.activeFilters.stream.groups?.length || 0;
                  if (groupCount > 1) {
                    parts.push('many');
                  }
                }
              } else {
                const streamCount = this.activeFilters.iteration.streams?.length || 0;
                if (streamCount > 1) {
                  parts.push('many');
                }
              }
            } else {
              const iterationCount = this.activeFilters.program.iterations?.length || 0;
              if (iterationCount > 1) {
                parts.push('many');
              }
            }
          } else {
            const programCount = this.activeFilters.subOrganization.programs?.length || 0;
            if (programCount > 1) {
              parts.push('many');
            }
          }
        } else {
          const subOrgCount = this.activeFilters.organization.subOrgs?.length || 0;
          if (subOrgCount > 1) {
            parts.push('many');
          }
        }
      }
      
      return parts.join(' / ');
    },
    applyFiltersToReports() {
      return (reports) => {
        if (!this.activeFilters) return reports;

        return reports.filter(report => {
          if (this.activeFilters.organization && report.org_id !== this.activeFilters.organization.id) return false;
          if (this.activeFilters.subOrganization && report.suborg_id !== this.activeFilters.subOrganization.id) return false;
          if (this.activeFilters.program && report.program_id !== this.activeFilters.program.id) return false;
          if (this.activeFilters.iteration && report.iteration_id !== this.activeFilters.iteration.id) return false;
          if (this.activeFilters.stream && report.stream_id !== this.activeFilters.stream.id) return false;
          if (this.activeFilters.group && report.group_id !== this.activeFilters.group.id) return false;

          if (this.activeFilters.searchQuery) {
            const query = this.activeFilters.searchQuery.toLowerCase();
            const fullName = report.full_name?.toLowerCase() || '';
            const programName = report.program_name?.toLowerCase() || '';
            const iterationName = report.iteration_name?.toLowerCase() || '';
            const reportName = report.report_template_name?.toLowerCase() || '';
            
            if (!fullName.includes(query) && !programName.includes(query) && 
                !iterationName.includes(query) && !reportName.includes(query)) {
              return false;
            }
          }
          return true;
        });
      };
    },

    surveyReportByProgramAndIteration: function () {
      return this.reportGroupData
        .sort((a, b) => b.survey_assignment_id - a.survey_assignment_id)
        .filter(function (el) {
          // Keep the container if it has ANY individual (non-group) report details
          return el.report_details.some(r => r.is_group_report != 1);
        }, this);
    },

    filteredSurveyReportByProgramAndIteration() {
      const filtered = this.surveyReportByProgramAndIteration.map(group => {
        return {
          ...group,
          report_details: group.report_details.filter(report => report.is_group_report != 1)
        };
      }).filter(group => group.report_details.length > 0);
      
      return this.applyFiltersToReports(filtered);
    },

    paginatedSurveyReports() {
      const start = (this.currentPageSurveyReports - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredSurveyReportByProgramAndIteration.slice(start, end);
    },

    totalPagesSurveyReports() {
      return Math.ceil(this.filteredSurveyReportByProgramAndIteration.length / this.itemsPerPage);
    },

    displayedPagesSurveyReports() {
      const pages = [];
      const maxVisible = 5;
      const total = this.totalPagesSurveyReports;
      
      if (total <= maxVisible) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        if (this.currentPageSurveyReports <= 3) {
          for (let i = 1; i <= 4; i++) pages.push(i);
          pages.push('...');
          pages.push(total);
        } else if (this.currentPageSurveyReports >= total - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 3; i <= total; i++) pages.push(i);
        } else {
          pages.push(1, '...', this.currentPageSurveyReports - 1, 
                    this.currentPageSurveyReports, this.currentPageSurveyReports + 1, 
                    '...', total);
        }
      }
      return pages;
    },
    tippingPointReport: function () {
      return this.tippingPointReportFilter.sort((a, b) =>
        a.full_name.localeCompare(b.full_name)
      );
    },

    filteredTippingPointReport() {
      return this.applyFiltersToReports(this.tippingPointReport);
    },

    tippingPointReportFilter: function () {
      return this.reportGroupData.filter(function (el) {
        return (
          el.tag_type == "has_coach_tipping_point" &&
          el.report_file == "TIPpingPointReport.html" &&
          el.is_group_report != 1 &&
          el.is_coach_report != 1
        );
      }, this);
    },

    pressurePointReport: function () {
      return this.pressurePointReportFilter.sort((a, b) =>
        a.full_name.localeCompare(b.full_name)
      );
    },

    filteredPressurePointReport() {
      return this.applyFiltersToReports(this.pressurePointReport);
    },

    filteredBoardReport() {
      return this.applyFiltersToReports(this.boardReport);
    },

    pressurePointReportFilter: function () {
      return this.reportGroupData.filter(function (el) {
        return (
          el.tag_type == "has_coach_pressure_point" &&
          el.report_file == "PressurePointReport.html" &&
          el.is_group_report != 1 &&
          el.is_coach_report != 1
        );
      }, this);
    },

    boardReport: function () {
      return this.boardReportFilter.sort((a, b) =>
        a.full_name.localeCompare(b.full_name)
      );
    },

    boardReportFilter: function () {
      return this.reportGroupData.filter(function (el) {
        return (
          el.tag_type == "has_board_report" &&
          el.report_file == "NED Report.html" &&
          el.is_group_report != 1 &&
          el.is_coach_report != 1
        );
      }, this);
    },
    alphabeticalOrderWithGroupCoachGroupReport: function () {
      return this.reportData.filter(function (el) {
        return el.group_name != null;
      }, this);
    },

    alphabeticalOrderWithoutGroupCoachGroupReport: function () {
      return this.reportData.filter(function (el) {
        return el.group_name == null;
      }, this);
    },

    coachProgramBaselineReport: function () {
      return this.alphabeticalOrderWithoutGroupCoachGroupReport
        .sort((a, b) => a.program_name.localeCompare(b.program_name))
        .filter(function (el) {
          return (
            el.report_file.includes('Baseline-Board-Coach-Report.html') ||
            el.report_file.includes('Baseline-Board-Coach-Report') ||
            el.report_file.includes('Baseline-Board-Coach') &&
            el.is_coach_report == 1 &&
            el.is_group_report == 1 &&
            el.coach_access_granted == 1
          );
        }, this);
    },

    filteredCoachProgramBaselineReport() {
      return this.applyFiltersToReports(this.coachProgramBaselineReport);
    },

    coachGroupBaselineReport: function () {
      return this.alphabeticalOrderWithGroupCoachGroupReport
        .sort((a, b) => a.group_name.localeCompare(b.group_name))
        .filter(function (el) {
          return (
            el.report_file.includes('Baseline-Board-Coach-Report.html') ||
            el.report_file.includes('Baseline-Board-Coach-Report') ||
            el.report_file.includes('Baseline-Board-Coach') &&
            el.is_coach_report == 1 &&
            el.is_group_report == 1 &&
            el.coach_access_granted == 1
          );
        }, this);
    },

    coachProgram5StepReport: function () {
      return this.alphabeticalOrderWithoutGroupCoachGroupReport
        .sort((a, b) => a.program_name.localeCompare(b.program_name))
        .filter(function (el) {
          return (
            (el.report_file.includes('5 Step Coach') ||
            el.report_file.includes('5 step coach') ||
            el.report_file.includes('5StepCoach')) &&
            el.is_coach_report == 1 &&
            el.is_group_report == 1 &&
            el.coach_access_granted == 1
          );
        }, this);
    },

    filteredCoachProgram5StepReport() {
      return this.applyFiltersToReports(this.coachProgram5StepReport);
    },

    coachGroup5StepReport: function () {
      const seen = new Set();
      return this.alphabeticalOrderWithGroupCoachGroupReport
        .sort((a, b) => a.group_name.localeCompare(b.group_name))
        .filter(function (el) {
          const matches = (
            (el.report_file.includes('5 Step Coach') ||
            el.report_file.includes('5 step coach') ||
            el.report_file.includes('5StepCoach')) &&
            el.is_coach_report == 1 &&
            el.is_group_report == 1 &&
            el.coach_access_granted == 1
          );
          if (!matches) return false;
          const key = `${el.group_id}-${el.iteration_id}-${el.report_file}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        }, this);
    },

    filteredCoachGroup5StepReport() {
      return this.applyFiltersToReports(this.coachGroup5StepReport);
    },

    coachTippingReport: function () {
      const seen = new Set();
      return this.reportData.filter(function (el) {
        const matches = (
          el.report_file.includes('Tipping Point Coach') ||
          el.report_file.includes('tipping point coach') ||
          el.report_file.includes('TIPpingPointCoach') &&
          el.is_coach_report == 1 &&
          el.is_group_report == 1 &&
          el.coach_access_granted == 1
        );
        if (!matches) return false;
        const key = `${el.group_id}-${el.iteration_id}-${el.report_file}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      }, this);
    },

    coachTippingReportSorted: function () {
      return this.coachTippingReport.sort((a, b) =>
        a.program_name.localeCompare(b.program_name)
      );
    },

    filteredCoachTippingReportSorted() {
      return this.applyFiltersToReports(this.coachTippingReportSorted);
    },

    coachPressureReport: function () {
      const seen = new Set();
      return this.reportData.filter(function (el) {
        const matches = (
          el.report_file.includes('Pressure Point Coach') ||
          el.report_file.includes('pressure point coach') ||
          el.report_file.includes('PressurePointCoach') &&
          el.is_coach_report == 1 &&
          el.is_group_report == 1 &&
          el.coach_access_granted == 1
        );
        if (!matches) return false;
        const key = `${el.group_id}-${el.iteration_id}-${el.report_file}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      }, this);
    },

    coachPressureReportSorted: function () {
      return this.coachPressureReport.sort((a, b) =>
        a.program_name.localeCompare(b.program_name)
      );
    },

    filteredCoachPressureReportSorted() {
      return this.applyFiltersToReports(this.coachPressureReportSorted);
    },

    coachProgramTalentSage360Report: function () {
      return this.alphabeticalOrderWithGroupCoachGroupReport
        .sort((a, b) => a.program_name.localeCompare(b.program_name))
        .filter(function (el) {
          return (
            el.report_file.includes('TalentSage 360 Coach') ||
            el.report_file.includes('Talent Sage Coach') ||
            el.report_file.includes('talent sage coach') ||
            el.report_file.includes('talentsage 360 coach') ||
            el.report_file.includes('TalentSage360Coach') &&
            el.is_coach_report == 1 &&
            el.is_group_report == 1 &&
            el.coach_access_granted == 1
          );
        }, this);
    },

    filteredCoachProgramTalentSage360Report() {
      return this.applyFiltersToReports(this.coachProgramTalentSage360Report);
    },

    coachProgramGeneralManager360Report: function () {
      return this.alphabeticalOrderWithGroupCoachGroupReport
        .sort((a, b) => a.program_name.localeCompare(b.program_name))
        .filter(function (el) {
          return (
            el.report_file.includes('General Manager 360 Coach') ||
            el.report_file.includes('General Manager Coach') ||
            el.report_file.includes('general manager coach') ||
            el.report_file.includes('general manager 360 coach') ||
            el.report_file.includes('GeneralManager360Coach') &&
            el.is_coach_report == 1 &&
            el.is_group_report == 1 &&
            el.coach_access_granted == 1
          );
        }, this);
    },

    filteredCoachProgramGeneralManager360Report() {
      return this.applyFiltersToReports(this.coachProgramGeneralManager360Report);
    },

    coachProgramSeniorExecProgram360Report: function () {
      return this.alphabeticalOrderWithGroupCoachGroupReport
        .sort((a, b) => a.program_name.localeCompare(b.program_name))
        .filter(function (el) {
          return (
            el.report_file.includes('Senior Executive Program 360 Coach') ||
            el.report_file.includes('SEP360Coach') ||
            el.report_file.includes('senior executive program 360 coach') ||
            el.report_file.includes('senior executive program 360') ||
            el.report_file.includes('SeniorExecProgram360Coach') &&
            el.is_coach_report == 1 &&
            el.is_group_report == 1 &&
            el.coach_access_granted == 1
          );
        }, this);
    },

    filteredCoachProgramSeniorExecProgram360Report() {
      return this.applyFiltersToReports(this.coachProgramSeniorExecProgram360Report);
    },

    coachProgramTeamLeader360Report: function () {
      return this.alphabeticalOrderWithGroupCoachGroupReport
        .sort((a, b) => a.program_name.localeCompare(b.program_name))
        .filter(function (el) {
          return (
            (el.report_file.includes('Team Leader 360 Coach') ||
            el.report_file.includes('TL360Coach') ||
            el.report_file.includes('team leader 360 coach') ||
            el.report_file.includes('Leader 360 Coach') ||
            el.report_file.includes('TeamLeader360Coach')) &&
            el.is_coach_report == 1 &&
            el.is_group_report == 1 &&
            el.coach_access_granted == 1
          );
        }, this);
    },

    filteredCoachProgramTeamLeader360Report() {
      return this.applyFiltersToReports(this.coachProgramTeamLeader360Report);
    },

    coachHelp360Report: function () {
      return this.alphabeticalOrderWithGroupCoachGroupReport
        .sort((a, b) => a.program_name.localeCompare(b.program_name))
        .filter(function (el) {
          return (
            el.report_file.includes('HELP 360 Coach') ||
            el.report_file.includes('help 360 coach') ||
            el.report_file.includes('help360coach') ||
            el.report_file.includes('HELP360Coach') &&
            el.is_coach_report == 1 &&
            el.is_group_report == 1 &&
            el.coach_access_granted == 1
          );
        }, this);
    },

    filteredCoachHelp360Report() {
      return this.applyFiltersToReports(this.coachHelp360Report);
    },

    coachEuroNav360Report: function () {
      return this.alphabeticalOrderWithGroupCoachGroupReport
        .sort((a, b) => a.program_name.localeCompare(b.program_name))
        .filter(function (el) {
          return (
            el.report_file.includes('EURONAV 360 Coach') ||
            el.report_file.includes('Euronav360Coach') ||
            el.report_file.includes('euronav360coach') ||
            el.report_file.includes('EURONAV360Coach') &&
            el.is_coach_report == 1 &&
            el.is_group_report == 1 &&
            el.coach_access_granted == 1
          );
        }, this);
    },

    filteredCoachEuroNav360Report() {
      return this.applyFiltersToReports(this.coachEuroNav360Report);
    },
  },
  beforeUnmount() {  
   this.abortController.abort();  
  },
};
</script>

<style scoped>
.main-div {
  min-width: 75vw;
  margin: 0;
  font-family: var(--font-family, 'Inter', sans-serif);
}
.card-header {
  padding: var(--space-sm, 16px);
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--card-border, #e2e8f0);
  border-bottom: none;
  border-radius: var(--radius-lg, 0.5rem) var(--radius-lg, 0.5rem) 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.card-header-title {
  font-size: var(--label-md-size, 12px);
  font-weight: 600;
  letter-spacing: var(--label-md-tracking, 0.05em);
  text-transform: uppercase;
  color: v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
}
.pill-btn {
  background: #ffffff;
  color: v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
  border: 1px solid v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
  border-radius: 9999px;
  padding: 6px 16px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
  font-family: var(--font-family, 'Inter', sans-serif);
  text-transform: none;
  letter-spacing: 0;
  white-space: nowrap;
  flex-shrink: 0;
}
.pill-btn:hover {
  background: v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
  color: #ffffff;
}
h4 { margin: 0; color: var(--primary, #002955); }
.label-btn {
  color: var(--on-primary, #ffffff);
  background-color: var(--primary, #002955);
}
.parent {
  display: flex;
  flex-wrap: wrap;
  padding: var(--space-sm, 16px);
  padding-bottom: var(--space-md, 24px);
  border: 1px solid var(--card-border, #e2e8f0);
  border-top: none;
  border-radius: 0 0 var(--radius-lg, 0.5rem) var(--radius-lg, 0.5rem);
  box-shadow: none;
  background: var(--card-bg, #ffffff);
}
.parent:has(> .card-header) {
  border-top: 1px solid var(--card-border, #e2e8f0);
  border-radius: var(--radius-lg, 0.5rem);
  margin-bottom: var(--space-md, 24px);
}
.parent:hover {
  border-color: var(--primary-container, #123f75);
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
}
.child {
  background: var(--surface-container-low, #eff4ff) !important;
  border: 1px solid var(--card-border, #e2e8f0);
  border-radius: var(--radius-lg, 0.5rem);
  text-align: center;
  min-width: 250px;
  max-width: 250px;
  margin: var(--space-xs, 8px);
  padding: var(--space-sm, 16px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: none;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}
.child:hover {
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
  border-color: var(--primary-container, #123f75);
}
.child-submitted {
  background: var(--surface-container, #e5eeff) !important;
  border: 1px solid var(--card-border, #e2e8f0);
  border-radius: var(--radius-lg, 0.5rem);
  text-align: center;
  min-width: 205px;
  max-width: 205px;
  margin: var(--space-xs, 8px);
  padding: var(--space-sm, 16px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: none;
}
.child-submitted:hover {
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
  border-color: var(--primary-container, #123f75);
}
.surveyLogo { width: 150px; height: auto; }
.btn-submit {
  text-decoration: none;
  margin-top: 10px;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}

.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
  color: var(--outline, #737781);
}
.tooltip .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: var(--inverse-surface, #213145);
  color: var(--inverse-on-surface, #eaf1ff);
  text-align: center;
  border-radius: var(--radius, 0.25rem);
  padding: 10px 6px;
  position: absolute;
  z-index: 1;
  font-size: 12px;
}
.tooltip:hover .tooltiptext { visibility: visible; }

.sample-report-href {
  text-decoration: none;
  cursor: pointer;
  color: var(--secondary, #36618b);
  font-weight: 500;
}

@media only screen and (min-width: 280px) and (max-width: 540px) {
  .main-div { margin: 0; }
}

.pdf-url { cursor: pointer; }
.baseline { width: 60%; margin-top: 10px; }

.switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
}
.switch input { opacity: 0; width: 0; height: 0; }
.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: var(--outline-variant, #c3c6d1);
  transition: 0.3s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.3s;
}
input:checked + .slider { background-color: var(--primary, #002955); }
input:focus + .slider { box-shadow: 0 0 1px var(--primary, #002955); }
input:checked + .slider:before { transform: translateX(24px); }
.slider.round { border-radius: 28px; }
.slider.round:before { border-radius: 50%; }

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}
@keyframes spinner-border {
  100% { transform: rotate(360deg); }
}
.sr-only {
  position: absolute;
  width: 1px; height: 1px;
  padding: 0; margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.text-primary { color: var(--primary, #002955) !important; }

.pagination-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: var(--space-md, 24px);
  padding: var(--space-md, 24px) var(--space-xs, 8px);
  flex-wrap: wrap;
}
.pagination-btn {
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--outline-variant, #c3c6d1);
  background-color: var(--card-bg, #ffffff);
  color: var(--on-surface, #0b1c30);
  border-radius: var(--radius, 0.25rem);
  cursor: pointer;
  font-size: var(--body-md-size, 14px);
  font-weight: 500;
  transition: all 0.2s ease;
  padding: 0 12px;
  font-family: var(--font-family, 'Inter', sans-serif);
}
.pagination-btn:hover:not(:disabled):not(.active) {
  background-color: var(--primary, #002955);
  color: var(--on-primary, #ffffff);
  border-color: var(--primary, #002955);
}
.pagination-btn.active {
  background-color: var(--primary, #002955);
  color: var(--on-primary, #ffffff);
  border-color: var(--primary, #002955);
  font-weight: 600;
}
.pagination-btn:disabled {
  background-color: var(--surface-container-low, #eff4ff);
  color: var(--outline-variant, #c3c6d1);
  cursor: not-allowed;
  border-color: var(--row-divider, #f1f5f9);
}
.pagination-info {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  font-size: 13px;
  color: var(--on-surface-variant, #434750);
  font-family: var(--font-family, 'Inter', sans-serif);
}
</style>
